// extracted by mini-css-extract-plugin
export default {"explanation":"Branding_explanation__-1xP7","colorPickersContainer":"Branding_colorPickersContainer__3n8Yf","colorPicker":"Branding_colorPicker__nkX95"};